import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RequiredOpportunityOwnerSignature from './RequireOpportunityOwnerSignature';
import { getUser } from '../../modules/Auth/AuthReducer';
import { getOpportunityOwnerSignature } from './reducer';

class RequiredSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      children, object, initiative, onCancel,
      isOwner, verified, owners, isAccount,
      collectorSignatures, authSignature, dynamicSenders,
    } = this.props;
    const comp = children ? children({ isOwner, verified, owners, collectorSignatures, authSignature, dynamicSenders }) : null;
    if (!initiative) {
      return comp;
    }
    return (
      <div className="animated fadeIn">
        <RequiredOpportunityOwnerSignature isAccount={isAccount} onCancel={onCancel} initiative={initiative} object={object}>
          {comp}
        </RequiredOpportunityOwnerSignature>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  let info = {};
  if (ownProps.object && ownProps.initiative) {
    const id = ownProps.isAccount ? ownProps.object.account_id : ownProps.object.opportunity_id;
    const collectorId = ownProps.initiative.defaultCollector?.collector_id;
    info = getOpportunityOwnerSignature(state, ownProps.initiative.client_id, ownProps.initiative.id, id, collectorId);
  }
  return {
    user: getUser(state),
    verified: info.signature === 'verified',
    isOwner: info.isOwner,
    owners: info.owners || [],
    authSignature: info.auth || null,
    collectorSignatures: info.collectors || [],
    dynamicSenders: info.dynamicSenders || [],
  };
}

RequiredSignature.propTypes = {
  children: PropTypes.func,
  object: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  }),
  isAccount: PropTypes.bool,
  initiative: PropTypes.shape({
    defaultCollector: PropTypes.shape({
      collector_id: PropTypes.string,
    }),
  }),
  onCancel: PropTypes.func,
  verified: PropTypes.bool,
  isOwner: PropTypes.bool,
  owners: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
  })),
  authSignature: PropTypes.shape({}),
  collectorSignatures: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
  })),
  dynamicSenders: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.string,
  })),
};
RequiredSignature.defaultProps = {
  children: null,
  isAccount: false,
  object: null,
  initiative: null,
  onCancel: null,
  verified: false,
  isOwner: false,
  owners: [],
  authSignature: null,
  collectorSignatures: [],
};


export default connect(mapStateToProps)(RequiredSignature);
